<template>
  <div v-if="media.track" v-bind:class="{showing: media.showing}">
    <div>displayName: {{media.displayName}}</div>
    <div>id: {{media.id}}</div>
    <div>peerId: {{media.peerId}}</div>
    <div>codec: {{media.codec}}</div>
    <div>type: {{media.type}}</div>
    <div>track: {{media.track && media.track.id}}</div>
    <div>deviceId: {{media.deviceId}}</div>
    <div>browser: {{media.mediaDetails}}</div>
    <div v-if="media.track">
      <button @click="show" v-bind:data-media-id="media.id">{{media.showing ? 'hide' : 'show'}}</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MediaItem',
    props: ['media', 'show']
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Media.vue?de601ac4